import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DisplayIcon } from './DisplayIcon';
import { DocumentMessageContent, DocumentMessageWrapper, DocumentMessagesWrapper } from './DocumentMessagesStyle';

const DocumentMessageComponent = ({ documentMessages, documentMessageActiveTab, index, messageType, getDocumentMessage }) => {
  const { t } = useTranslation();

  const contentColor = useMemo(() => {
    switch (messageType) {
      case 'Warning':
        return 'warning';
      case 'Error':
        return 'error';
      case 'Info':
      default:
        return 'primary';
    }
  }, [messageType]);

  return (
    <DocumentMessagesWrapper active={Boolean(documentMessageActiveTab)}>
      {documentMessageActiveTab === index &&
        documentMessages
          .filter(x => x.messageType === messageType)
          .map((item, index) => {
            return (
              <DocumentMessageWrapper id={'documentMessage_' + getDocumentMessage(messageType) + '_content'} key={index}>
                <DisplayIcon messageType={messageType} />
                <DocumentMessageContent color={contentColor}>
                  {t(`Offer.Edit.DocumentMessages.${item.messageCode}`, item.data)}
                </DocumentMessageContent>
              </DocumentMessageWrapper>
            );
          })}
    </DocumentMessagesWrapper>
  );
};

DocumentMessageComponent.propTypes = {
  documentMessages: PropTypes.array,
  documentMessageActiveTab: PropTypes.any.isRequired,
  index: PropTypes.any.isRequired,
  children: PropTypes.node,
  messageType: PropTypes.string.isRequired,
  getDocumentMessage: PropTypes.func
};

export default DocumentMessageComponent;
